export default {
  "nav.spreadsheet": "Tableur",
  "nav.categories": "Catégories",
  "nav.guides": "Guides",
  "nav.faq": "FAQ",
  "nav.home": "Accueil",
  "nav.visitMain": "Visiter le site principal",
  "nav.shoppingGuide": "Guide d'achat",

  "hero.eyebrow": "Le centre de ressources Basetao Spreadsheet",
  "hero.title": "Basetao Spreadsheet : produits, vendeurs et guides d'achat",
  "hero.subtitle": "Explorez des catégories de produits sélectionnées, des conseils vendeurs et des guides d'achat pratiques — le tout organisé dans un hub clair et facile à parcourir.",
  "hero.cta1": "Basetao Spreadsheet",
  "hero.cta2": "Acheter maintenant",
  "hero.note": "Tous les liens produits s'ouvrent sur le site principal",

  "dropdown.label": "Parcourir les catégories",
  "dropdown.placeholder": "Choisir une catégorie de produits",

  "categories.title": "Explorer les catégories de produits",
  "categories.subtitle": "Accédez directement aux produits qui vous intéressent. Chaque catégorie ouvre une liste filtrée sur le site principal.",
  "categories.shoes": "Chaussures",
  "categories.hoodies": "Hoodies / Sweats",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Vestes",
  "categories.pants": "Pantalons / Shorts",
  "categories.headwear": "Couvre-chefs",
  "categories.sets": "Ensembles",
  "categories.underwear": "Sous-vêtements / Caleçons",
  "categories.jersey": "Maillots",
  "categories.accessories": "Accessoires",
  "categories.bags": "Sacs",
  "categories.belts": "Ceintures",
  "categories.perfumes": "Parfums",
  "categories.other": "Autres articles",
  "categories.viewAll": "Tout parcourir sur le site principal",

  "about.title": "Qu'est-ce que le Basetao Spreadsheet ?",
  "about.p1": "Le Basetao Spreadsheet rassemble des liens produits, des notes vendeurs et des conseils d'achat dans un annuaire facile à parcourir. Au lieu de chercher un article à la fois, vous obtenez une carte claire de chaque catégorie — des chaussures aux sacs et parfums.",
  "about.p2": "Chaque catégorie ouvre une vue filtrée sur le site principal, vous permettant de passer d'une idée générale à un produit précis en un seul clic. Résultat : une façon plus rapide et plus sereine de trouver ce que vous cherchez.",
  "about.p3": "En plus de l'annuaire, nous publions des guides d'achat pratiques sur les vendeurs, la livraison et le contrôle qualité — tous rédigés pour vous aider à acheter en toute confiance.",

  "guides.title": "Derniers guides Basetao",
  "guides.subtitle": "Des guides pratiques et originaux pour parcourir et acheter en toute confiance.",
  "guides.cardTitle": "Basetao Spreadsheet : guide complet (2026)",
  "guides.cardDesc": "Apprenez comment fonctionne le tableur, parcourez les catégories, trouvez des vendeurs fiables et comprenez la livraison et le contrôle qualité.",
  "guides.readArticle": "Lire le guide complet",
  "guides.updated": "Mis à jour en août 2026",
  "guides.badge": "Guide d'achat",

  "faq.title": "Questions fréquentes",
  "faq.subtitle": "Des réponses rapides sur le Basetao Spreadsheet et son utilisation.",
  "faq.q1": "Qu'est-ce que le Basetao Spreadsheet ?",
  "faq.a1": "C'est un annuaire organisé de catégories de produits, de liens et de notes d'achat qui pointent vers le site principal.",
  "faq.q2": "Comment parcourir les produits ?",
  "faq.a2": "Utilisez le menu déroulant des catégories ou les cartes ci-dessous. Chaque option ouvre une liste de produits filtrée sur le site principal.",
  "faq.q3": "Est-ce gratuit ?",
  "faq.a3": "Oui — parcourir l'annuaire et lire les guides est gratuit. Les achats sont gérés sur le site principal.",
  "faq.q4": "Comment acheter un article ?",
  "faq.a4": "Choisissez une catégorie, trouvez votre produit sur le site principal, puis finalisez le paiement là-bas.",

  "cta.title": "Prêt à explorer le Basetao Spreadsheet ?",
  "cta.subtitle": "Parcourez toutes les catégories au même endroit, puis accédez directement aux produits souhaités.",
  "cta.primary": "Explorer Basetao Spreadsheet",
  "cta.secondary": "Visiter le site principal",

  "footer.disclaimer": "Ce site est une ressource d'information indépendante. Les informations produits, vendeurs, prix et disponibilités peuvent changer. Vérifiez toujours les détails importants sur le site principal avant d'acheter.",
  "footer.rights": "© 2026 Basetao Spreadsheet. Tous droits réservés.",
  "footer.resources": "Ressources",
  "footer.explore": "Explorer",
  "footer.home": "Accueil",
  "footer.guide": "Guide Basetao Spreadsheet",
  "footer.categories": "Catégories de produits",
  "footer.visitMain": "Visiter le site principal",

  "article.notFound": "Article introuvable",
  "article.notFoundDesc": "L'article que vous recherchez n'existe pas ou a été déplacé.",
};